/* eslint-disable no-console */
import '../app/app';
import WizardInfo from '../wizard-info/wizard-info';

const initInjector = angular.injector(['ng']);
const $http = initInjector.get('$http');

/*global AppBuildConfig*/
$http.get(`${AppBuildConfig.backendUrl }/wizard/info`).then(response => {

  document.title = `Configuration Wizard: ${response.data.productPresentationName}`;
  /**
   * Store wizard info
   */
  WizardInfo.constant('wizardInfo', response.data);

  /**
   * Bootstrapping application
   */
  angular.element(document).ready(() => {
    angular.bootstrap(document, ['installer'], {
      strictDi: true
    });
  });

}, errorResponse => {
  if (console.log) {
    console.log('Can\'t load initial configuration', errorResponse);
  }
  document.title = 'Loading error';
});




// WEBPACK FOOTER //
// ./src/blocks/bootstrap/bootstrap.js